"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _excluded = ["classes", "src", "height", "width", "circular"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = function styles(theme) {
  return {
    root: {},
    circular: {
      border: "1px solid ".concat(theme.palette.grey.light),
      borderRadius: '100%'
    }
  };
};

var Image = function Image(props) {
  var classes = props.classes,
      src = props.src,
      height = props.height,
      width = props.width,
      circular = props.circular,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: (0, _clsx2["default"])(classes.root, _defineProperty({}, classes.circular, circular)),
    style: {
      height: height,
      width: width,
      backgroundImage: "url(".concat(src, ")"),
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat'
    }
  }, rest));
};

Image.defaultProps = {
  classes: {},
  height: 144,
  width: 144
};
Image.propTypes = {
  classes: _propTypes["default"].any,
  height: _propTypes["default"].number.isRequired,
  width: _propTypes["default"].number.isRequired,
  circular: _propTypes["default"].bool,
  src: _propTypes["default"].string.isRequired
};

var _default = (0, _reactJss["default"])(styles)(Image);

exports["default"] = _default;